import { Accordion, AccordionTab } from "primereact/accordion"
import { Button } from "primereact/button";
import { useState } from "react";

const PanelSection = ({ myPanels, handleSelectPanel, handleAddExercise, t }: any) => {
    const [activeIndex, setActiveIndex] = useState(-1);

    const handleSelectPanelOverride = (panel: any, e:any) => {
        e.stopPropagation();
        handleSelectPanel(panel);
    }

    const headerContent = (panel: any, idx:number) => {
        return (
            <div
                className="flex align-items-center justify-content-between m-2 pr-2"
                style={{
                    height: "2rem"
                }}
            >
                <div className="flex gap-4 align-items-center">
                    <div  className="p-3 w-3rem h-3rem flex align-items-center justify-content-center" style={{backgroundColor: "rgba(234, 235, 240, 1)", borderRadius: "10px"}}>
                        <i className={`pi pi-angle-${activeIndex === idx ? "up" : "down"} text-3xl`}></i>
                    </div>
                    <p className="text-lg">{panel.name}</p>
                </div>
                <Button
                    style={{
                        backgroundColor: "rgba(224, 229, 248, 1)",
                        border: "none",
                        borderRadius: "10px",
                        height: "3rem",
                        width: "12rem",
                        minWidth: "12rem",
                        maxWidth: "12rem",
                        boxSizing: "border-box",
                        color: "rgba(87, 97, 133, 1)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "0 0.75rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    onClick={(e:any) => handleSelectPanelOverride(panel, e)}
                >
                    <span className="font-normal flex align-items-center gap-2" style={{ justifyContent: "center", width: "100%" }}>
                        <i className="pi pi-plus text-sm"></i>
                        {t("addToPrescription")}
                    </span>
                </Button>
            </div>
        )
    }

    const exerciseDivs = (panelExerciseList: any, isPanelLengthGreatherThanFour: boolean) => {
        return panelExerciseList.exerciseProcedure.map((exercise: any,index:any) => {
            return (
                <div key={index} className="flex flex-column">
                    <div
                        className="flex align-items-center justify-content-between my-1 mx-2 p-2 pr-5" style={{ borderRadius: "10px", }}>
                        <div className="flex justify-content-between align-items-center w-full">
                            <div className="flex gap-4 align-items-center">
                                <img src={exercise.exerciseImg} width={50} height={50} style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }} />
                                <p className="font-bold text-md" style={{ color: "#2D3967" }}>{exercise.exerciseName}</p>
                            </div>
                            {isPanelLengthGreatherThanFour && (
                                <Button 
                                    style={{
                                        backgroundColor: "rgba(224, 229, 248, 1)",
                                        border: "none",
                                        color: 'rgba(87, 97, 133, 1)',
                                        borderRadius: "10px",
                                        height: "2.5rem",
                                        width: "2.5rem",
                                    }}
                                    text
                                    icon="pi pi-plus"
                                    onClick={() => handleAddExercise(exercise)}
                                />
                            )}
                        </div>
                    </div>
                    {index !== panelExerciseList.exerciseProcedure.length-1 && <div style={{border:"1px solid #e5e7eb"}}></div>} 
                </div>
            )
        })
    }

    const createDynamicTabs = () => {
        return myPanels.map((panel: any, index:number) => {
            const isPanelLengthGreatherThanFour = panel?.exerciseProcedure?.length > 3;
            return (
                <AccordionTab key={panel.id} header={() => headerContent(panel, index)}>
                    {exerciseDivs(panel, isPanelLengthGreatherThanFour)}
                </AccordionTab>
            );
        });
    };

    return (
        <div className="w-full exercisePanelsAccordion overflow-auto">
            <Accordion activeIndex={activeIndex} onTabChange={(e:any) => setActiveIndex(e.index)}>{createDynamicTabs()}</Accordion>
        </div>
    )
}

export default PanelSection